module.exports = __webpack_public_path__ + "img/0005.3a036ba2.jpg";